import { identity } from "@suse-o11y/identity";
import { useMemo } from "react";

import { TraversalData } from "../../../../components/react/topology-query/TopologyQueryFunctions";
import { useCurrentInitialViewQuery, useCurrentViewQuery } from "../viewpoint/ViewPointHooks";

import { allFilterNames } from "./TopologyQueryFilterSelectors";

export const useCurrentTraversalData = (): undefined | TraversalData => {
	const currentQuery = useCurrentViewQuery().getOrElse("");

	return useMemo(
		() => TraversalData.fromSTQL(currentQuery, allFilterNames).fold(() => undefined, identity),
		[currentQuery],
	);
};

export const useInitialTraversalData = (): TraversalData => {
	const currentInitialViewQuery = useCurrentInitialViewQuery().getOrElse("");

	return useMemo(
		() => TraversalData.fromSTQL(currentInitialViewQuery, allFilterNames).getOrElse(TraversalData.empty),
		[currentInitialViewQuery],
	);
};
